import { BanditosTemplate } from 'templates/Shared/Banditos';
import { SpecialOfferProps } from '../types';

export const BanditosSpecialOffer: React.FC<SpecialOfferProps> = ({
  prices,
  dataTestId,
  productsList,
  backgroundImage,
  backgroundColor = {
    colorOne: '#A342C6',
  },
  ribbonBadges = [],
  selectOffer,
  isFree,
  availability,
  timer,
  badges = [],
  inMobileMock = false,
  offerDescription,
  collectText,
}) => {
  return (
    <BanditosTemplate
      prices={prices}
      productList={productsList}
      backgroundSrc={backgroundImage}
      backgroundColor={backgroundColor}
      ribbonBadges={ribbonBadges}
      selectOffer={selectOffer}
      dataTestId={dataTestId}
      isFree={isFree}
      availability={availability}
      timer={timer}
      badges={badges}
      inMobileMock={inMobileMock}
      offerDescription={offerDescription}
      collectText={collectText}
    />
  );
};
